<template>
  <DBox
    :id="'cmp-distribution-order-sidewindow-orderline'"
    :addButton="false"
    :addLink="false"
    @add_click="onAddOrderLines"
  >
    <div class="ut-fc ut-fh">
      <div class="ut-fc ut-flex-1" style="height: calc(100% - 148px)">
        <NTable
          class="dbox1"
          id="distribution-order-sidewindow-backorder"
          :config="tableConfig"
          :headers="Headers"
          :items="list"
          :showNoItems="false"
        >
          <template v-slot:thead="{ thcon }">
            <tr style="color: var(--text-5)">
              <th v-bind="thcon('catalog_no')">
                <div class="ut-fc">
                  <span>{{ $t("catalog_no") }} </span>
                  <span>{{ $t("barcode") }}</span>
                </div>
              </th>
              <th v-bind="thcon('label')">
                <div class="ut-fc">
                  <span>{{ $t("label") }}</span>
                  <span>{{ $t("Format") }}</span>
                </div>
              </th>
              <th v-bind="thcon('artist')">
                <div class="ut-fc">
                  <span>{{ $t("artist") }}</span>
                  <span>{{ $t("ps_title") }}</span>
                </div>
              </th>
              <th v-bind="thcon('notes')">
                <span> {{ $t("notes") }} </span>
              </th>
              <th v-bind="thcon('promo')">
                <span> {{ $t("promo") }} </span>
              </th>
              <th v-bind="thcon('quantity')">
                <span class="ut-text-right"> {{ $t("quantity") }}</span>
              </th>
              <th v-bind="thcon('ppu')">
                <span class="ut-text-right"> {{ $t("main_ppu") }}</span>
              </th>
              <th v-bind="thcon('discount')">
                <span class="ut-text-right"> {{ $t("discount") }}</span>
              </th>
              <th v-bind="thcon('total')">
                <span> {{ $t("total") }}</span>
              </th>
              <th v-bind="thcon('options')"></th>
            </tr>
          </template>
          <template v-slot:item="{ item, tdcon }">
            <tr :key="item.orderline_id">
              <td v-bind="tdcon('product')">
                <div class="ut-flex">
                  <div class="circular-status">
                    <div
                      class="circular-status-color"
                      style="
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        margin-right: 8px;
                      "
                      :style="{
                        'background-color': `#${item['label_status_colour']}`,
                        border: item['label_status_colour']
                          ? `1px solid #${item['label_status_colour']}`
                          : '1px solid gray',
                      }"
                    ></div>
                  </div>

                  <div class="ut-fc ut-txtov">
                    <span class="ut-txtov" :title="item['catalog_no']">{{
                      item["catalog_no"]
                    }}</span>
                    <span class="ut-txtov" :title="item['barcode']">{{
                      item["barcode"]
                    }}</span>
                  </div>
                </div>
              </td>
              <td v-bind="tdcon('label')">
                <div class="ut-fc ut-txtov">
                  <span class="ut-txtov" :title="item['label_name']">{{
                    item["label_name"]
                  }}</span>
                  <span class="ut-txtov" :title="item['format_name']">{{
                    item["format_name"]
                  }}</span>
                </div>
              </td>

              <td v-bind="tdcon('artist')">
                <div class="ut-fc ut-txtov">
                  <span class="ut-txtov" :title="item['release_alt_artist']">{{
                    item["release_alt_artist"]
                  }}</span>
                  <span class="ut-txtov" :title="item['release_alt_title']">{{
                    item["release_alt_title"]
                  }}</span>
                </div>
              </td>
              <td v-bind="tdcon('notes')">
                <TextField2
                  type="text"
                  class="dbox1"
                  id="notes"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['notes']"
                  :bb="'0px'"
                  @change="(e) => onTextFieldChange(e, item)"
                />
              </td>
              <td v-bind="tdcon('promo')">
                <span>{{ getPromoQuantityText(item) }}</span>
              </td>
              <td v-bind="tdcon('quantity')">
                <TextField2
                  type="number"
                  class="dbox1"
                  id="order_qty"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['order_qty']"
                  :bb="'none'"
                  :ta="'right'"
                  @change="(e) => onTextFieldChange(e, item)"
                />
              </td>
              <td v-bind="tdcon('ppu')">
                <TextField2
                  type="number"
                  class="dbox1"
                  id="ppu"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['ppu']"
                  :bb="'0px'"
                  :ta="'right'"
                  @change="(e) => onTextFieldChange(e, item)"
                />
              </td>
              <td v-bind="tdcon('discount')">
                <TextField2
                  type="text"
                  class="dbox1"
                  id="discount"
                  :showLabel="false"
                  :disabled="false"
                  :value="`${
                    parseFloat(item['discount'])
                      ? parseFloat(item['discount']) + ' %'
                      : ''
                  }`"
                  :bb="'0px'"
                  :ta="'right'"
                  @change="(e) => onTextFieldChange(e, item)"
                />
              </td>
              <td v-bind="tdcon('total')">
                <span class="ut-txtov" :title="$dft.curr(item['total'])">{{
                  $dft.curr(item["total"])
                }}</span>
              </td>
              <td v-bind="tdcon('options')">
                <div class="dt-icon-container">
                  <img
                    @click.stop="(e) => deleteOrderLine(item)"
                    src="static/icons/delete.svg"
                    class="dt-icon v5 s1"
                  />
                </div>
              </td>
            </tr>
          </template>
        </NTable>
      </div>
      <div
        style="
          min-height: 48px;
          width: 100%;
          padding: 10px;
          padding-right: 10px;
          background-color: white;
        "
        class="ut-flex ut-jend"
      >
        <div
          @click="onAddOrderLines"
          class="ut-link ut-text-accent5"
          style="flex: 1"
        >
          + Add New Order Lines
        </div>
        <div style="flex: 1; text-align: right">
          <span v-if="!isNaN(totalValue)" style="color: var(--text-secondary)"
            >Value :<b style="color: #000">
              {{ $dft.curr(totalValue) }}
              {{
                selectedOrder &&
                selectedOrder.order_details_tab_summary &&
                selectedOrder.order_details_tab_summary.order &&
                selectedOrder.order_details_tab_summary.order.currency_iso
              }}</b
            >
          </span>
        </div>
      </div>
      <div
        class="ut-flex"
        style="
          min-height: 100px;
          padding-bottom: 10px;
          padding-left: 10px;
          width: 100%;
        "
      >
        <div class="ut-flex-1">
          <TextField
            id="subject"
            class="m0"
            :label="$t('Deal Memo')"
            :placeholder="`${this.$t('Deal Memo')}`"
            :textarea="true"
            :height="90"
            :showLabel="false"
            :disabled="true"
            :value="
              selectedOrder &&
              selectedOrder.order_details_tab_summary &&
              selectedOrder.order_details_tab_summary.account &&
              selectedOrder.order_details_tab_summary.account.deal_memo
            "
            :rightIcon="'static/icons/question.svg'"
            :bb="'none'"
            :icon="'search-blue'"
          />
        </div>
        <div
          class="ut-flex ut-fh ut-flex-1 ut-jend ut-aend"
          style="padding-right: 6px"
        >
          <button @click="onXLSImportClick" class="dt-button v5 s8">
            {{$t('xls_import')}}
          </button>
          <button v-if="selectedOrder.show_button_auto_backorder" @click="onAutoBackOrderClick" class="dt-button v5 s8">
            {{$t('auto_backorder')}}
          </button>
          <button @click="onDiscountClick" class="dt-button v5 s8">
            {{ $dft.capHead($t("discount")) }}
          </button>
        </div>

        <!-- @change="onTextFieldValueChange" -->
      </div>
    </div>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { productsListLDTRoutes } from "../../../catalog/router/routes";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  props: {
    selectedOrder: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        headerHeight: 52,
        rowHeight: 52,
      }),
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("product", {}),
        createTableHeader("label", {}),
        createTableHeader("artist", { text: this.$t("title") }),
        createTableHeader("format", { ta: "right", f: 0.8 }),
        createTableHeader("notes", {}),
        createTableHeader("promo", { mw: 60 }),
        createTableHeader("quantity", { ta: "right", mw: 75 }),
        createTableHeader("ppu", { text: "PPU", ta: "right", mw: 75 }),
        createTableHeader("discount", { ta: "right", mw: 75 }),
        createTableHeader("total", { ta: "right", mw: 80 }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },

    list: function () {
      return this.selectedOrder?.order_details_tab_summary?.orderlines || [];
    },
    totalValue: function () {
      if (this.list.length > 0) {
        return this.list.reduce((accum, cur) => {
          accum = parseFloat(accum) + parseFloat(cur.total);
          return accum.toFixed(2);
        }, 0.0);
      }
    },
  },

  methods: {
    getPromoFOCLabel: function (item) {
      if (item.promo_foc == 1) {
        return "Promo";
      } else if (item.promo_foc == 2) {
        return "FOC";
      }
      return "";
    },

    onTextFieldChange: function (e, item) {
      const { name, value } = e;

      this.$emit("changed", { name, value, item });
    },

    onAddOrderLines: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_order_line",
          order_id:
            this.selectedOrder?.order_details_tab_summary?.order?.order_id,
        },
      });
    },

    deleteOrderLine: async function (item) {
      // const confirmationResult = await confirmDelete(
      //   this.$t("order_line"),
      //   `#${item.order_id}-${item["catalog_no"]} | ${item.order_qty}`
      // );

      // if (confirmationResult == "OK") {
        this.$emit("delete", item);
      // }
    },

    onDiscountClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "price_code_discount_modal",
          order_id:
            this.selectedOrder?.order_details_tab_summary?.order?.order_id,
        },
      });
    },

    onXLSImportClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "dfile_uploader",
          order_id:
            this.selectedOrder?.order_details_tab_summary?.order?.order_id,
        },
      });
    },
    onItemClick: function (item) {
      console.log(item, ":::::::::");
      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: item.product_id,
          tab: "overview",
        },
      });
    },
    getPromoQuantityText(item) {
      if (item.promo_foc == "1") {
        return "Promo";
      } else if (item.promo_foc == "2") {
        return "FOC";
      } else {
        return "";
      }
    },
    onAutoBackOrderClick: function () {
      this.$emit("autoBackOrder", true);
    },
    //MARK: Methods
  },
};
</script>
<style lang="scss">
.cmp-distribution-order-sidewindow-orderline {
  .dt-ntable {
    tbody {
      tr {
        td {
          //white-space: pre-wrap;
        }
      }
    }
  }
}
</style>